import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const trustAccount = () => ({
    "collection-agency" : {
        header : "Trust account",
        text : ['Every collection agency must maintain a trust account in a fincial institution of a class approved by the Registrar.'],
        headerRenewal : "Trust account",
        textRenewal : [
            'Every collection agency must maintain a trust account in a fincial institution of a class approved by the Registrar. Review your trust account information.'
        ],
        navigation : {
            next : ROUTE_PATH.SURETY_BOND,
            nextRenewal : ROUTE_PATH.COLLECTORS_REVIEW
        }
    }, 
    "debt-management-agency" : {
        header : "Trust account",
        text : [
            'Every debt management agency must maintain a trust account in a fincial institution of a class approved by the Registrar.'],
        headerRenewal : "Trust account",
        textRenewal : [
            'Every debt management agency must maintain a trust account in a fincial institution of a class approved by the Registrar. Review your trust account information.'
        ],
        navigation : {
            next : ROUTE_PATH.SURETY_BOND,
            nextRenewal : ROUTE_PATH.COLLECTORS_REVIEW
        }
    }
})

const trustAccountSlice = createSlice({
    name : 'trustAccount',
    initialState : trustAccount(),
    reducers : {

    }
})

export default trustAccountSlice.reducer
